import { render, staticRenderFns } from "./articleDetail.vue?vue&type=template&id=5d1fc95e&scoped=true"
import script from "./articleDetail.vue?vue&type=script&lang=js"
export * from "./articleDetail.vue?vue&type=script&lang=js"
import style0 from "./articleDetail.vue?vue&type=style&index=0&id=5d1fc95e&prod&lang=less"
import style1 from "./articleDetail.vue?vue&type=style&index=1&id=5d1fc95e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1fc95e",
  null
  
)

export default component.exports